import React, { useCallback, useEffect, useState } from "react";
import { getData, postData, postFormData } from '../middleware/apiMiddleware';
import s from './KeyListeningFile.module.css'; // 模块化样式
import { useNavigate } from "react-router-dom";
import { RedButton, GreenButton, BlueButton } from './MyButton';
import { MyInput } from './Utilities/MyInput';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function KeyListeningFile(prop) {	
	const navigate = useNavigate();
	const itemId = prop.itemId;
	const [fetchCompleted, setFetchCompleted] = useState(true);

	const [isUploading, setIsUploading] = useState(false);
	const [pdfPath, setPdfPath] = useState('');
	const [imagePaths, setImagePaths] = useState([]);
	const [uploadError, setUploadError] = useState('');

	const [filePaths, setFilePaths] = useState('');

	const fetchData = async () => {
		setFetchCompleted(false);
		let res = await getData('listeningApi/listFilesByItemId?itemId=' + itemId, navigate)
		console.log(res.data)
		setFilePaths(res.data);
		setFetchCompleted(true);
	};

	const updateFileType = async (id, type) => {
		try {
			const payload = { id, type };
			await postData("listeningApi/updateFileType", payload, navigate);
			fetchData();
		} catch (err) {
			console.error('更新文件类型失败：', err);
			alert('更新类型失败，请重试');
		}
	};

	const addFile = async (path, type) => {
		const payload = { itemId, path, type };
		await postData("listeningApi/addFile", payload, navigate);
	};
	
	const deleteFile = async (id) => {
		const payload = { id };
		await postData("listeningApi/deleteFile", payload, navigate);
		fetchData();
	};
	
	const updateFileOrdering = async (id, ordering) => {
		const payload = { id, ordering };
		await postData("listeningApi/updateFileOrdering", payload, navigate);
	};

	const uploadPdf = async (selectedFile) => {
		if (selectedFile.type !== 'application/pdf') {
			setUploadError('仅支持上传PDF文件！');
			return null;
		}
		try {
			setIsUploading(true);
			setUploadError('');
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("pdffile", selectedFile);
			let res = await postFormData("utility/uploadPdfFile", data, navigate);
			return res.data;
		} catch (err) {
			setUploadError(err.message || '文件上传失败，请重试');
			return null;
		} finally {
			setIsUploading(false);
		}
	};

	const generalItemUpload = async (selectedFile) => {
		try {			
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
		} catch (err) {
			console.error('通用文件上传失败：', err);
			alert('文件上传失败，请重试');
			return null;
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	if (!fetchCompleted) {
		return (<MyComponentLoading />);
	}

	return (
		<div className={s.container}>
			<div className={s.uploadArea}>
				<label htmlFor="pdf-upload" className={s.custom_file_upload} style={{ margin: "5px", cursor: "pointer" }}>
					<input 
						id="pdf-upload" 
						type="file" 
						accept=".pdf,.jpg,.jpeg,.png,.gif" 
						style={{ display: "none" }} 
						onChange={async (e) => {
							const file = e.target.files[0];
							if (!file) return;
							const isPdfFile = file.type === 'application/pdf' || 
											file.name.toLowerCase().endsWith('.pdf');
							try {
								if (isPdfFile) {
									const uploadResult = await uploadPdf(file);
									if (uploadResult) {
										addFile(uploadResult.pdf, 'question');
										for (const imgPath of uploadResult.images) {
											addFile(imgPath, 'question');
										}
									}
								} else {
									const path = await generalItemUpload(file);
									if (path) {
										addFile(path, 'question');
									}
								}
							} catch (err) {
								console.error('文件上传失败：', err);
							} finally {
								e.target.value = '';
								fetchData();
							}
						}} 
					/>
					{isUploading ? 'Uploading...' : 'Upload PDF or Images'}
				</label>
				{/* 错误提示改用模块化样式 */}
				{uploadError && (
					<div className={s.uploadError}>
						{uploadError}
					</div>
				)}
			</div>

			{filePaths.length > 0 && (
				<div className={s.fileListContainer}>
					{filePaths.map((obj) => (
						<div key={obj.id} className={s.fileItem}>
							<input
								type="number"
								className={s.orderInput}
								value={obj.ordering || ''} // 处理ordering为空的情况
								min="1" // 限制最小值为1
								onChange={(e) => {
									const newOrderValue = e.target.value;
									// 1. FIRST: Update local filePaths state (so input reflects the change instantly)
									setFilePaths(prevFilePaths => 
									prevFilePaths.map(file => 
										// Find the matching file by id and update its ordering locally
										file.id === obj.id ? { ...file, ordering: newOrderValue } : file
									)
									);
									// 2. THEN: Sync the new value to the backend (API call)
									updateFileOrdering(obj.id, newOrderValue);
								}}
								placeholder="排序" // 占位提示
							/>
							
							<select
								value={obj.type}
								className={s.fileTypeSelect}
								onChange={(e) => {
									updateFileType(obj.id, e.target.value);
								}}
							>
								<option value="question">question</option>
								<option value="answer">answer</option>
							</select>
							{/* 文件链接改用模块化样式 */}
							<a 
								href={obj.path} 
								target="_blank" 
								rel="noopener noreferrer"
								className={s.filePathLink}
							>
								{obj.path}
							</a>
							{/* 删除按钮容器改用模块化样式 */}
							<div className={s.deleteButtonContainer}>
								<RedButton isEnabled={true} clickedAction={()=>deleteFile(obj.id)} bText={"X"} />
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
}